import React from "react";
import styled from "@emotion/styled";

const Spinner = () => (
  <Wrapper>
    <P>Envoi de votre message. Veuillez patientez.</P>
    <Ring>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </Ring>
  </Wrapper>
);

const Wrapper = styled.div`
  text-align: right;
`;

const Ring = styled.div`
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    margin: 3px;
    border: 3px solid #7a9282;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #7a9282 transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;

const P = styled.div`
  display: inline-block;
  font-size: 0.82em;
  font-weight: 600;
`;

export default Spinner;
